import LinkCusstom from '@/components/common/LinkCusstom'
import RePasswordModal from '@/components/common/LoginRelatedComponent/component/Forget/components/RePasswordModal'
import SvgIcon from '@/components/common/SvgIcon'
import ROUTER from '@/routes/ROUTER'
import { buildMenuFromTabs, flattenLeaves } from '@/routes/buildMenuFromTabs'
import { useIsLogin } from '@/shared/context'
import queryClient from '@/shared/queries/queryClient'
import { useAppSelector } from '@/shared/redux/hooks'
import {
  changeAuthorization,
  selectListTabs,
  setListTabs,
  setUserInfo,
} from '@/shared/redux/slices/appGlobal.slice'
import { clearLocalStorage, clearSessionStorage } from '@/shared/utils/storage'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Divider, Menu } from 'antd'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import '../popupStyle.scss'
import { StyleMenuAccount } from '../styles'

const MenuUser = () => {
  const { userInfo } = useSelector((state: any) => state?.appGlobal)
  const [rePasswordModal, setRePasswordModal] = useState(false)
  const { isLogin } = useIsLogin()
  const dispatch = useDispatch()
  const listTabs = useAppSelector(selectListTabs)

  const navigate = useNavigate()
  const location = useLocation()

  const getActiveKey = (): string[] => {
    if (rePasswordModal) {
      return ['3']
    }
    const currentPath = location.pathname || ''
    if (currentPath.startsWith('/user') || currentPath.includes(ROUTER.THONG_TIN_TAI_KHOAN)) {
      return ['2']
    }
    if (currentPath.startsWith('/acs') || currentPath.includes('acs')) {
      return ['4']
    }
    if (currentPath.startsWith('/hrm,') || currentPath.includes('hrm')) {
      return ['5']
    }
    if (currentPath !== '/') {
      return ['1']
    }
    return []
  }

  const activeKey = getActiveKey()

  // ponytail: thay hasAdminPermission (MenuConfig tĩnh, không khớp quyền BE thật) bằng đúng
  // menu động đang hiện ở sidebar (buildMenuFromTabs từ GetListTab) — nút truy cập chỉ hiện
  // khi user thật sự có ít nhất 1 tab, và luôn nhảy tới route đầu tiên user thấy trên sidebar.
  // AccountType (1=Admin, 2=Doanh nghiệp — Service/OrderService.cs so sánh == 2) quyết định nhãn nút.
  const menuItems = buildMenuFromTabs(listTabs)
  const hasMenuAccess = menuItems.length > 0
  const accessLabel = userInfo?.accountType === 2 ? 'Doanh nghiệp' : 'Quản trị hệ thống'
  const startPage = flattenLeaves(menuItems)[0]?.path ?? ROUTER.HOME

  const handleLogout = async () => {
    if (isLogin) {
      // Logout client-side thuần, khớp legacy session.service.ts — BE không có endpoint logout
      clearLocalStorage()
      clearSessionStorage()
      dispatch(setUserInfo({}))
      dispatch(setListTabs([]))
      dispatch(changeAuthorization(false))
      queryClient.clear()
      return navigate(ROUTER?.HOME)
    }
  }

  return (
    <StyleMenuAccount>
      <div className="menu-account">
        <Menu className="dropdown-option" selectedKeys={activeKey}>
          <div className="account-infor">
            <div className="d-flex-start g-10">
              <div style={{ textAlign: 'center' }}>
                <Avatar
                  src={userInfo?.avatar}
                  size={52}
                  icon={<UserOutlined style={{ fontSize: '36px' }} />}
                />
              </div>
              <div className="sumary-infor-user">
                {!!userInfo?.username && (
                  <div className="account-name max-line1 fz-16 fw-600">{userInfo?.username}</div>
                )}
                {!!userInfo?.email && (
                  <div className="account-name max-line1">{userInfo?.email}</div>
                )}
              </div>
            </div>
            <Divider />
          </div>
          {hasMenuAccess && (
            <Menu.Item key="1">
              <LinkCusstom
                to={startPage}
                noUnderline={true}
                className="btn-function"
                style={{ display: 'flex', color: 'inherit' }}
              >
                <SvgIcon name="config" />
                <span className="fw-400">{accessLabel}</span>
              </LinkCusstom>
            </Menu.Item>
          )}
          <Menu.Item key="2">
            <LinkCusstom
              to={ROUTER.THONG_TIN_TAI_KHOAN}
              noUnderline={true}
              className="btn-function"
              style={{ display: 'flex', color: 'inherit' }}
            >
              <SvgIcon name="user_login" />
              <span className="fw-400">Thông tin cá nhân</span>
            </LinkCusstom>
          </Menu.Item>

          <Menu.Item key="3" onClick={() => setRePasswordModal(true)}>
            <div className="btn-function strok-btn-function">
              <SvgIcon name="reset-pass" />
              <span className="fw-400">Đổi mật khẩu </span>
            </div>
          </Menu.Item>

          <Divider className="m-0" />

          <Menu.Item key="6" style={{ color: '#ED1117' }} onClick={handleLogout}>
            <div className="btn-logout">
              <SvgIcon name="logoutIcon" />
              Đăng xuất
            </div>
          </Menu.Item>
        </Menu>
      </div>

      {!!rePasswordModal && (
        <RePasswordModal
          rePasswordModal={rePasswordModal}
          handleCancel={() => setRePasswordModal(false)}
        />
      )}
    </StyleMenuAccount>
  )
}

export default MenuUser
